import { selectors } from 'data'
import React from 'react'
import { useSelector } from 'react-redux'
import { getZendeskAuthToken } from 'services/api/zendesk'
import isEmbedded from 'utils/isEmbedded'
import useScript from 'utils/useScript'

const VIP_TAGS = ['VIP', 'PRE_VIP']

function getSettings() {
  return {
    webWidget: {
      color: {
        button: '#0C6CF2',
        header: '#0C6CF2',
        launcher: '#DFE3EB',
        launcherText: '#000000',
        theme: '#DFE3EB'
      },
      position: {
        horizontal: 'right',
        vertical: 'bottom'
      }
    }
  }
}

const Zendesk = () => {
  useScript(
    'https://static.zdassets.com/ekr/snippet.js?key=5efcb63c-11d2-4a97-a17f-23cc6ef4aec0',
    async () => {
      try {
        // Set initial settings
        window.zESettings = getSettings()

        // eslint-disable-next-line no-inner-declarations
        function resetZendeskChatPosition() {
          window.zE('webWidget', 'updateSettings', window.zESettings)
        }
        resetZendeskChatPosition()

        window.zE(function () {
          window.$zopim(function () {
            // Setup authentication using Zendesk's recommended pattern
            window.$zopim.livechat.authenticate({
              jwtFn: async function (callback) {
                try {
                  const result = await getZendeskAuthToken()
                  if (!result.ok) {
                    throw new Error(`Failed to get Zendesk auth token: ${result.error}`)
                  }
                  callback(result.response.jwt)
                } catch (error) {
                  // eslint-disable-next-line no-console
                  console.error('Failed to authenticate Zendesk chat:', error)
                }
              }
            })

            const urlParams = new URLSearchParams(window.location.search)
            const isEmbedded = urlParams.get('type') === 'institutional'
            const isMobile = window.matchMedia('(max-width: 768px)').matches

            if (isMobile || isEmbedded) {
              window.$zopim.livechat.button.hide()
              return
            }

            window.$zopim.livechat.setOnConnected(function () {
              const DEPT = 'Blockchain Exchange'
              const department_status = window.$zopim.livechat.departments.getDepartment(DEPT)
              if (department_status.status === 'online') {
                window.$zopim.livechat.departments.filter([DEPT])
                window.$zopim.livechat.departments.setVisitorDepartment(DEPT)
                window.$zopim.livechat.concierge.setAvatar(
                  'https://exchange.blockchain.com/trade/resources/bc-exchange-logo-web.png'
                )
                window.$zopim.livechat.concierge.setName('Blockchain.com Exchange')
                window.$zopim.livechat.concierge.setTitle('Live Support')
              } else {
                window.$zopim.livechat.setStatus('offline')
              }

              resetZendeskChatPosition()
            })
          })
        })
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Failed to initialize Zendesk chat:', error)
      }
    },
    {
      id: 'ze-snippet',
      nonce: 'dqqMIKs3Hb48v1CDudZ7fPRhuiawsY3J'
    }
  )

  return null
}

function ZendeskTrigger() {
  const userTags = useSelector(selectors.auth.getTags)
  const isVipUser = Object.keys(userTags ?? {}).some((key) => VIP_TAGS.includes(key))
  if (isEmbedded() || !isVipUser) return null
  return <Zendesk />
}

export default ZendeskTrigger
